import { Button, Card, CardActions, CardContent, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { useAuth } from "context/AuthContext";
import React, { useEffect, useState } from "react"
import './SubmitPrintDialog.css'


interface SubmitPrintDialogProps {
    isOpen: boolean;
    onAccept: (shouldPrintRightSide: boolean, shouldPrintLeftSide: boolean) => void;
    onCancel: () => void;
}

const SubmitPrintDialog: React.FC<SubmitPrintDialogProps> = ({ isOpen, onAccept, onCancel }) => {
    const [userLegalConsentChecked, setUserLegalConsentChecked] = useState(false)
    const [leftInsolePrintChecked, setLeftInsolePrintChecked] = useState(true)
    const [rightInsolePrintChecked, setRightInsolePrintChecked] = useState(true)
    const { user } = useAuth();
    const [isRondom, setIsRonom] = useState(false);

    useEffect(() => {
        if (isOpen === true) {
            setUserLegalConsentChecked(false);
            if (user?.isAdmin === false) {
                if (user?.group?.IsRondom) {
                    setIsRonom(true);
                    setUserLegalConsentChecked(true);
                }
                else setIsRonom(false);
            }
        }
    }, [isOpen])

    return (isOpen &&
        <div className="submit-print-dialog-wrapper">
            <Card sx={{ minWidth: 300 }}>
                <CardContent sx={{ display: 'flex', flexDirection: 'column', padding: '10px 10px 0 10px' }}>
                    <Typography gutterBottom sx={{ color: 'var(--accent-color)', fontSize: 18, marginBottom: 0 }}>
                        Print
                    </Typography>
                    <FormControlLabel
                        sx={{ alignItems: 'start', marginBottom: 0, minWidth: 0 }}
                        control={
                            <Checkbox
                                checked={userLegalConsentChecked}
                                onChange={(e) => { setUserLegalConsentChecked(e.target.checked) }}
                            ></Checkbox>
                        }
                        label={<Typography sx={{ fontSize: 12, color: 'var(--text-color-secondary)', marginTop: '12px' }}>By checking this box and upon sending the custom orthotics designs to the 3D printer you adopt and accept the liability for these custom orthotics designs and agree to effect the payments according to the terms and conditions of your agreement with T-Soles.</Typography>}
                    >
                    </FormControlLabel>
                </CardContent>
                <CardActions sx={{ justifyContent: 'space-between' }}>
                    <div>
                        <FormControlLabel
                            sx={{ alignItems: 'start', marginBottom: 0, minWidth: 0, width: 'fit-content' }}
                            control={
                                <Checkbox
                                    checked={leftInsolePrintChecked}
                                    onChange={(e) => { setLeftInsolePrintChecked(e.target.checked) }}
                                ></Checkbox>
                            }
                            label={<Typography sx={{ fontSize: 14, color: 'var(--accent-color)', marginTop: '11px' }}>Left</Typography>}
                        >
                        </FormControlLabel>
                        <FormControlLabel
                            sx={{ alignItems: 'start', marginBottom: 0, minWidth: 0, width: 'fit-content' }}
                            control={
                                <Checkbox
                                    checked={rightInsolePrintChecked}
                                    onChange={(e) => { setRightInsolePrintChecked(e.target.checked) }}
                                ></Checkbox>
                            }
                            label={<Typography sx={{ fontSize: 14, color: 'var(--accent-color)', marginTop: '11px' }}>Right</Typography>}
                        >
                        </FormControlLabel>
                    </div>
                    <div>
                        <Button size="small" onClick={onCancel}>Cancel</Button>
                        <Button
                            disabled={!userLegalConsentChecked || !(leftInsolePrintChecked || rightInsolePrintChecked)}
                            size="small"
                            onClick={() => onAccept(rightInsolePrintChecked, leftInsolePrintChecked)}
                        >
                            Send Print
                        </Button>
                    </div>
                </CardActions>
            </Card>
        </div>
    );
}
export default SubmitPrintDialog;